import React from "react";
import { LogOut } from "lucide-react";

interface AdminHeaderProps {
  activeTab: "memes" | "stickers" | "templates" | "users";
  memesCount: number;
  stickersCount: number;
  templatesCount: number;
  usersCount: number;
  onLogout: () => void;
}

const AdminHeader: React.FC<AdminHeaderProps> = ({
  activeTab,
  memesCount,
  stickersCount,
  templatesCount,
  usersCount,
  onLogout,
}) => {
  return (
    <div className="bg-white/70 backdrop-blur-sm rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 lg:p-12 shadow-xl border border-pink-100 mb-8">
      <div className="flex justify-between items-center">
        <div className="text-center flex-1">
          <img
            src="/oz_and_tali.png"
            alt="Logo"
            className="h-16 mx-auto mb-4"
          />
          <h1
            className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-2"
            dir="rtl"
          >
            פאנל ניהול
          </h1>
          <p className="text-lg text-gray-700" dir="rtl">
            {activeTab === "memes"
              ? `${memesCount} מימז`
              : activeTab === "stickers"
              ? `${stickersCount} סטיקרים`
              : activeTab === "templates"
              ? `${templatesCount} תבניות`
              : `${usersCount} משתמשים`}
          </p>
        </div>
        <button
          onClick={onLogout}
          className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors flex items-center space-x-2"
        >
          <LogOut className="h-4 w-4" />
          <span>יציאה</span>
        </button>
      </div>
    </div>
  );
};

export default AdminHeader;
